import { hocHook } from "../../../@hoc/hoc-hook";
import { Article1 } from "./article1";

export default hocHook(Article1);
